import React, { useContext, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./pages/global/Topbar";
import Sidebar from "./pages/global/Sidebar";
import Dashboard from "./pages/dashboard";
import Invoices from "./pages/users";
import Users from "./pages/users";
import Bar from "./pages/bar";
import NewUser from "./pages/newuser";
import Line from "./pages/line";
import Pie from "./pages/pie";
import FAQ from "./pages/faq";
import Geography from "./pages/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import getLPTheme from './pages/getLPTheme';
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./pages/calendar/calendar";
import SignInSide from "./pages/login";
import LandingPage from "./pages/home/home";
import SignUpSide from "./pages/register";
import Transactions from "./pages/transactions";
import Contacts from "./pages/users";
import Team from "./pages/users";
import { AuthContext } from './context/AuthContext';
import ForgotPassword from "./pages/reset";
import RegisterSupplier from "./pages/addsupplier";
import Suppliers from "./pages/suppliers";
import Supplier from "./pages/supplier";
import Orders from "./pages/orders";
import Order from "./pages/order";
import NewRequests from "./pages/new-requests";
import NewRequest from "./pages/new-request";
import Documents from "./pages/documents";
import Customers from "./pages/customers";
import User from "./pages/user";
import Document from "./pages/document";
import Customer from "./pages/customer";
import NewCustomer from "./pages/newcustomer";
import Products from "./pages/products";
import Services from "./pages/services";
import Organizations from "./pages/organizations";
import Reports from "./pages/reports";
import Product from "./pages/product";
import Service from "./pages/service";
import Organization from "./pages/organization";
import Report from "./pages/report";
import MapComponent from "./pages/ride";
import Settings from "./pages/settings";
import Categories from "./pages/categories";
import ActiveOrders from "./pages/active-orders";
import PendingOrders from "./pages/pending-orders";
import NewOrganization from "./pages/new-organization";
import CancelledOrders from "./pages/cancelled-orders";
import UploadMembers from "./pages/uploadusers";
import Drivers from "./pages/drivers";
import Vehicles from "./pages/vehicles";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const { currentuser } = useContext(AuthContext);
  const [mode, setMode] = React.useState('dark');
  const LPtheme = createTheme(getLPTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  return (
    <>
    {currentuser || token ?
    <ColorModeContext.Provider value={colorMode}>
      {/* <ThemeProvider theme={theme}> */}
      <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <div className="app">
          {!token &&
          <Sidebar isSidebar={isSidebar} />
          }
          <main className="content">
            {!token &&
            <Topbar setIsSidebar={setIsSidebar} />
            }
            <Routes>
              {/* <Route path="/" element={<Dashboard />} /> */}
              <Route path="/members/upload" element={<UploadMembers />} />
              {/* <Route path="/" element={<Dashboard />} /> */}
              <Route path="/" element={<MapComponent />} />
              <Route path="/ride" element={<MapComponent />} />
              <Route path="/drivers" element={<Drivers />} />
              <Route path="/vehicles" element={<Vehicles />} />
              <Route path="/home" element={<Dashboard />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/requests" element={<NewRequests />} />
              <Route path="/active-orders" element={<ActiveOrders />} />
              <Route path="/cancelled-orders" element={<CancelledOrders />} />
              <Route path="/pending-orders" element={<PendingOrders />} />
              <Route path="/request/:id" element={<NewRequest />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/supplier/:id" element={<Supplier />} />
              <Route path="/history" element={<Orders />} />
              <Route path="/history/:id" element={<Order />} />
              <Route path="/suppliers/add" element={<RegisterSupplier />} />
              <Route path="/users" element={<Users />} />
              <Route path="/user/:id" element={<User />} />
              <Route path="/users/add" element={<NewUser />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/add" element={<NewCustomer />} />
              <Route path="/customer/:id" element={<Customer />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/document/:id" element={<Document />} />
              <Route path="/transactions" element={<Users />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/services" element={<Services />} />
              <Route path="/service/:id" element={<Service />} />
              <Route path="/organizations" element={<Organizations />} />
              <Route path="/organization/:id" element={<Organization />} />
              <Route path="/organizations/add" element={<NewOrganization />} />
              <Route path="/report" element={<Reports />} />
              <Route path="/report/:id" element={<Report />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/bar" element={<Bar />} />
              <Route path="/pie" element={<Pie />} />
              <Route path="/line" element={<Line />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/calendar" element={<Calendar />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
    :
    <div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/reset" element={<ForgotPassword />} />
          <Route path="/sign-in" element={<SignInSide />} />
          <Route path="/sign-up" element={<SignUpSide />} />
        </Routes>
    </div>
    }
    </>
  );
}

export default App;
